function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12,.99A6.2694,6.2694,0,0,0,5.74,7.25c0,6.14014,5.67,11.78,5.91,12.02l.35.34009.35-.34009c.24-.24,5.91-5.87988,5.91-12.02A6.26942,6.26942,0,0,0,12,.99Zm0,9.07007a2.22,2.22,0,1,1,2.22-2.22A2.215,2.215,0,0,1,12,10.06006Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.02,19.62012c0,2.21-4.65,3.38989-9.02,3.38989s-9.02-1.17993-9.02-3.38989c0-1.56006,2.35-2.6001,5.13-3.08008A26.24194,26.24194,0,0,0,10.95,19.98l.35.3501L12,21.02l.7-.68994.35-.3501a25.4434,25.4434,0,0,0,2.83-3.45C18.55,16.99,21.02,17.96008,21.02,19.62012Z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var SvgZones = function SvgZones(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zones.94a04266.svg";
export { ForwardRef as ReactComponent };